import { defineStore } from 'pinia'
import { api } from '@/api/axios'
import { getToken } from '@/utils/tokenStorage'

export const useCobrosStore = defineStore('cobros', {
  state: () => ({
    cobros: [],
    search: '',
    perPage: 20,
    page: 1,
    currentPage: 1,
    totalCobros: 0,
    totalPages: 1
  }),
  actions: {
    async fetchCobros({ page, search, perPage, fecha = null } = {}) {
      try {
        const response = await api.get('/cobros', {
          headers: {
            Authorization: `Bearer ${getToken()}`
          },
          params: {
            page: page || this.page,
            search: search || this.search,
            per_page: perPage || this.perPage,
            fecha: fecha || null
          }
        })
        this.cobros = response.data.items
        this.totalCobros = response.data.total
        this.totalPages = response.data.pages
        this.perPage = response.data.per_page
        this.page = response.data.page
        return this.cobros
      } catch (error) {
        console.error('Error al obtener cobros:', error)
        throw error
      }
    },
    async createCobro(cobro) {
      try {
        const response = await api.post('/cobros', cobro, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.cobros.push(response.data)
        return response.data
      } catch (error) {
        console.error('Error al crear cobro:', error)
        throw error
      }
    },
    async updateCobro(cobro) {
      try {
        const response = await api.put(`/cobros/${cobro.id}`, cobro, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        const index = this.cobros.findIndex((c) => c.id === cobro.id)
        if (index !== -1) {
          this.cobros[index] = response.data
        }
        return response.data
      } catch (error) {
        console.error('Error al actualizar cobro:', error)
        throw error
      }
    },
    async deleteCobro(id) {
      try {
        await api.delete(`/cobros/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.cobros = this.cobros.filter((c) => c.id !== id)
      } catch (error) {
        console.error('Error al eliminar cobro:', error)
        throw error
      }
    },
    setSearch(search) {
      this.search = search
    },
    setRows(rows) {
      this.rows = rows
    },
    setPage(page) {
      this.page = page
    },
    async getCobro(id) {
      try {
        const response = await api.get(`/cobros/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        return response.data
      } catch (error) {
        console.error('Error al obtener cobro:', error)
        throw error
      }
    },
    async getUsuarios() {
      try {
        const response = await api.get('/usuarios', {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        return response.data.items
      } catch (error) {
        console.error('Error al obtener usuarios:', error)
        throw error
      }
    }
  }
})
